export const simCardFormatter = (value) => {
  if (value === 1) return "ایرانسل";
  if (value === 2) return "همراه اول";
  if (value === 3) return " رایتل";
  return "-";
};
